import React from "react";

export default function Terms() {
  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <div className="label-eyebrow mb-3">Legal</div>
      <h1 className="font-display text-5xl tracking-tight mb-8">Terms of Service</h1>
      <p className="text-[hsl(var(--muted-foreground))] leading-relaxed">Last updated: {new Date().toLocaleDateString()}</p>

      <h2 className="font-display text-2xl mt-10 mb-3">Using Humanly</h2>
      <p>By creating an account, you agree to use Humanly for lawful purposes only. You are responsible for the text you submit and the way you use the output.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">Subscriptions</h2>
      <p>Paid plans renew automatically until canceled. You can cancel any time from your account. Unused monthly words do not roll over.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">Acceptable use</h2>
      <p>Don't use Humanly to impersonate real people, evade academic integrity policies, or produce content that violates any applicable law. We reserve the right to suspend accounts that abuse the service.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">No warranty</h2>
      <p>Humanly is provided "as is". While we work hard to keep it reliable and accurate, we make no guarantees about outputs.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">Contact</h2>
      <p>hello@humanly.app</p>
    </article>
  );
}
